// extracted by mini-css-extract-plugin
module.exports = {"recommendedFit":"ju","sizeIndicatorIcon":"ku","recommendedFitContainer":"lu","calculateSize":"mu","linkStyleCopy":"nu"};